;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { pluralize } from '@qogita/format/string'
import { ONE_DAY_MS, ONE_HOUR_MS, ONE_MINUTE_MS } from 'src/core/constants/time'

export const getFormattedTimeUntilExpirationDate = (
  milliseconds: number,
): string => {
  if (milliseconds < 0) return 'Expired'

  if (milliseconds < ONE_MINUTE_MS) return 'Less than 1 minute'

  if (milliseconds < ONE_HOUR_MS) {
    const minutes = Math.floor(milliseconds / ONE_MINUTE_MS)

    return pluralize({ word: 'minute', count: minutes })
  }

  if (milliseconds < ONE_DAY_MS) {
    const hours = Math.floor(milliseconds / ONE_HOUR_MS)

    return pluralize({ word: 'hour', count: hours })
  }

  const days = Math.floor(milliseconds / ONE_DAY_MS)

  return pluralize({ word: 'day', count: days })
}
